/* istanbul ignore file */
import { FlowEntry, FlowRoute } from '../../types'
import { mapRequirementToRoute } from '../../requirementsMapping'
import { addressEdit } from 'utils/FlowProvider/redirects'
import { finishOnboarding } from 'utils/FlowProvider/flows/laterOnboarding/redirects'

const laterOnboarding: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [],
  },
  {
    page: FlowRoute.LaterInterstitial,
    actions: [
      { name: 'continue', goTo: mapRequirementToRoute },
      { name: 'goBack', goTo: finishOnboarding },
    ],
    progress: { stepIndex: 0, stepPartialProgress: 0 },
    isFirstPage: true,
  },
  {
    page: FlowRoute.DateOfBirth,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      { name: 'continue', goTo: mapRequirementToRoute },
      {
        name: 'choose',
        goTo: () => FlowRoute.AddressSuggestion,
      },
      {
        name: 'more_info',
        goTo: () => FlowRoute.AddressInvalid,
      },
    ],
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.SSN,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.EmploymentStatus,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.MaritalStatus,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.TaxFilingType,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.CombinedAnnualIncome,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.AnnualIncome,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.SelfEmployedIncome,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.Employees,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.LaterSuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.LaterIraRecommendation,
      },
    ],
    progress: { stepIndex: 1 },
  },
  {
    page: FlowRoute.LaterIraRecommendation,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.PreviewPortfolio,
      },
    ],
    progress: { stepIndex: 2 },
  },
  {
    page: FlowRoute.PreviewPortfolio,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.RecurringInvestment,
      },
      {
        name: 'about_portfolio',
        stepEvent: 'about_portfolio',
        goTo: () => FlowRoute.AboutPortfolio,
      },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.AboutPortfolio,
    actions: [{ name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.PreviewPortfolio }],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 94,
      stepOverallProgress: 70,
    },
  },
  {
    page: FlowRoute.RecurringInvestment,
    actions: [
      {
        name: 'one-time',
        goTo: () => FlowRoute.OneTimeInvestment,
      },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'continue', goTo: () => FlowRoute.Success },
      { name: 'product-onboarding', goTo: finishOnboarding },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.OneTimeInvestment,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Success,
      },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'product-onboarding', goTo: finishOnboarding },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.Funding,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Institutions,
      },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      {
        name: 'choose',
        goTo: () => FlowRoute.ChooseFundingSource,
      },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'skip', goTo: () => FlowRoute.Success },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'skip', goTo: () => FlowRoute.Success },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      {
        name: 'skip',
        goTo: () => FlowRoute.Success,
      },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.BankLinkSuccess,
      },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.RecurringInvestment,
      },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.RoundUpsInterstitial,
    actions: [{ name: 'continue', goTo: () => FlowRoute.RecurringInvestment }],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.Success,
    actions: [],
    progress: { stepIndex: 4 },
  },
  {
    page: FlowRoute.AddressInvalid,
    actions: [
      {
        name: 'continue',
        goTo: addressEdit,
      },
    ],
  },
  {
    page: FlowRoute.AddressSuggestion,
    actions: [
      {
        name: 'continue',
        goTo: mapRequirementToRoute,
      },
      {
        name: 'update',
        goTo: addressEdit,
      },
    ],
  },
]

export default laterOnboarding
